import React, { useState } from 'react';
import { Avatar } from './Avatar';
import { USERS } from './data';
import { Comment } from './types';
interface CommentThreadProps {
  comments: Comment[];
  currentUser: string;
}
export function CommentThread({
  comments: init,
  currentUser
}: CommentThreadProps) {
  const [text, setText] = useState('');
  const [comments, setComments] = useState<Comment[]>(init);
  const send = () => {
    if (!text.trim()) return;
    setComments(p => [...p, {
      user: currentUser,
      text,
      time: 'Just now'
    }]);
    setText('');
  };
  return <div style={{
    marginTop: 8,
    borderTop: '1px solid #F0EDE8',
    paddingTop: 8
  }} data-id="element-75">
      {comments.map((c, i) => <div key={i} style={{
      display: 'flex',
      gap: 7,
      marginBottom: 8
    }} data-id="element-76">
          <Avatar uid={c.user} size={20} data-id="element-77" />
          <div data-id="element-78">
            <span style={{
          fontSize: 11,
          fontWeight: 700
        }} data-id="element-79">
              {USERS[c.user]?.name}
            </span>
            <span style={{
          fontSize: 9.5,
          color: '#94A3B8',
          marginLeft: 5
        }} data-id="element-80">
              {c.time}
            </span>
            <div style={{
          fontSize: 12,
          color: '#4A5B6C',
          lineHeight: 1.5,
          marginTop: 1
        }} data-id="element-81">
              {c.text}
            </div>
          </div>
        </div>)}
      <div style={{
      display: 'flex',
      gap: 6
    }} data-id="element-82">
        <Avatar uid={currentUser} size={20} data-id="element-83" />
        <input value={text} onChange={e => setText(e.target.value)} onKeyDown={e => e.key === 'Enter' && send()} placeholder="Add a comment…" style={{
        flex: 1,
        padding: '6px 9px',
        border: '1px solid #E2E8F0',
        borderRadius: 5,
        fontSize: 11.5,
        fontFamily: 'inherit',
        outline: 'none'
      }} data-id="element-84" />
        <button onClick={send} style={{
        padding: '6px 10px',
        borderRadius: 5,
        border: 'none',
        background: text.trim() ? '#2D7A6E' : '#E2E8F0',
        color: text.trim() ? 'white' : '#94A3B8',
        fontSize: 10.5,
        fontWeight: 700,
        cursor: text.trim() ? 'pointer' : 'default',
        fontFamily: 'inherit'
      }} data-id="element-85">
          Send
        </button>
      </div>
    </div>;
}